/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './ion-slider.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../src/app/shared/ion-slider/ion-slider.component';
const styles_IonSliderComponent:any[] = [i0.styles];
export const RenderType_IonSliderComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_IonSliderComponent,data:{}});
export function View_IonSliderComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{inputEl:0}),(_l()(),i1.ɵeld(0,[[1,0],['inputEl',
      1]],(null as any),0,'input',[['type','text']],(null as any),(null as any),(null as any),
      (null as any),(null as any)))],(null as any),(null as any));
}
export function View_IonSliderComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-ion-slider',
      ([] as any[]),(null as any),(null as any),(null as any),View_IonSliderComponent_0,
      RenderType_IonSliderComponent)),i1.ɵdid(4374528,(null as any),0,i2.IonSliderComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const IonSliderComponentNgFactory:i1.ComponentFactory<i2.IonSliderComponent> = i1.ɵccf('admin-ion-slider',
    i2.IonSliderComponent,View_IonSliderComponent_Host_0,{type:'type',min:'min',max:'max',
        from:'from',to:'to',step:'step',values:'values',hide_min_max:'hide_min_max',
        hide_from_to:'hide_from_to',grid:'grid',grid_num:'grid_num',prefix:'prefix',
        postfix:'postfix',max_postfix:'max_postfix'},{change:'change'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2lvbi1zbGlkZXIvaW9uLXNsaWRlci5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQvaW9uLXNsaWRlci9pb24tc2xpZGVyLmNvbXBvbmVudC50cyIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2lvbi1zbGlkZXIvaW9uLXNsaWRlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2lvbi1zbGlkZXIvaW9uLXNsaWRlci5jb21wb25lbnQudHMuSW9uU2xpZGVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGlucHV0ICNpbnB1dEVsIHR5cGU9XCJ0ZXh0XCI+IiwiPGFkbWluLWlvbi1zbGlkZXI+PC9hZG1pbi1pb24tc2xpZGVyPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztxRENBQTtNQUFBO01BQUE7OztvQkNBQTtNQUFBO21DQUFBLFVBQUE7TUFBQTs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/ion-slider/ion-slider.component.ngfactory.ts